import { type QueryHookOptions, useQuery } from "@apollo/client";
import { EventCancelProgressQuery } from "../graphql/queries";
import type {
  EventCancelProgressQueryType,
  EventCancelProgressQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useEventCancelProgressQuery = (
  options?: QueryHookOptions<
    EventCancelProgressQueryType,
    EventCancelProgressQueryVariablesType
  >
) =>
  useQuery<EventCancelProgressQueryType, EventCancelProgressQueryVariablesType>(
    EventCancelProgressQuery,
    options
  );
